import { useContext } from 'react';
import { EventContext } from './EventContext';

export function useEvent() {
  const context = useContext(EventContext);
  
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  
  return context;
}